import { STATUS } from 'modules/reservation'
import { PAYMENT_METHOD } from 'modules/billing'

export const getBillingLabel = reservation => {
  if (
    reservation.canShowReceipt &&
    reservation.billing.paymentMethod === PAYMENT_METHOD.CARD
  ) {
    return '領収書'
  }

  if (reservation.canShowReceipt) {
    return '請求書'
  }

  if (
    reservation.status === STATUS.REQUESTED ||
    reservation.status === STATUS.POSTPAY
  ) {
    return '見積書'
  }

  return ''
}
